import { SortDirectionDropdownMenuProps, useSortDirectionDropdownMenu } from './hooks';
import { StyledConfigDropdownMenu } from './sort-popover.styled';

export const SortDirectionDropdownMenu = ({
  dataType,
  onChange,
  value,
}: SortDirectionDropdownMenuProps): React.ReactElement => {
  const {
    onChange: handleChange,
    options,
    value: dropdownValue,
  } = useSortDirectionDropdownMenu({ value, dataType, onChange });
  return (
    <StyledConfigDropdownMenu options={options} placeholder="Direction" value={dropdownValue} onChange={handleChange} />
  );
};
